import React from "react";
import { Container, Row } from "react-bootstrap";
import ContentSkeleton from "./ContentSkeleton";
import ImageSkeleton from "./ImageSkeleton";

const BackgroundSkeleton = () => {
  return (
    <Container>
      <Row>
        <ImageSkeleton />
        <ContentSkeleton />
      </Row>
    </Container>
  );
};

export default BackgroundSkeleton;
